import { render } from "./trend.vue?vue&type=template&id=b862a9b4&ts=true"
import script from "./trend.vue?vue&type=script&lang=ts"
export * from "./trend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__